export function Spinner({ label, size = 28 }: { label?: string; size?: number }) {
  return (
    <span className="spinner" role="status" aria-label={label} style={{ width: size, height: size }}>
      <span className="spinner__ring" />
    </span>
  );
}
